//#region src/utils/dom.ts
function e() {
	window.nostojs = window.nostojs ?? function(e) {
		(window.nostojs.q = window.nostojs.q ?? []).push(e);
	};
}
//#endregion
//#region src/lib/nostojs.ts
async function t(e) {
	return window.nostojs(e);
}
//#endregion
//#region src/lib/settings.ts
var n = null;
typeof window < "u" && (e(), t((e) => {
	n = e.internal.getSettings();
}));
function r() {
	return n;
}
function i(e) {
	n = e;
}
//#endregion
export { e as i, i as n, t as r, r as t };
